import React from 'react';
import BrandLogo from '@assets/logo.png';
const AppLogo = () => {
    const styles = {
        logoImg: {
            height: '100%',
        },
    };
    return (<div data-testid="app-logo" style={{height:"100%"}}>
        <img src={BrandLogo} style={styles.logoImg} />
    </div>
    );
};
export default AppLogo;
